/*************************************
 *
 * 公共 store
 *
 *************************************/

const state = {
  pageLoading: false,
  nim: null
}

const mutations = {
  SET_LOADING: (state, loading) => {
    state.pageLoading = loading
  },

  /**
   * nim
   *
   * @param state
   * @param nimObj
   * @constructor
   */
  SET_NIM: (state, nimObj) => {
    state.nim = nimObj
  }
}

const actions = {
  /**
   * 设置 loading 动画
   *
   * @param commit
   * @param loading
   */
  setLoading ({ commit }, loading) {
    commit('SET_LOADING', loading)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js